import { DownloadDocumentType } from '@commenda/types';
import { fetcher } from '@commenda/utils';

export async function downloadDocument(body: {
  fileId: number;
  fileType: DownloadDocumentType;
}): Promise<Blob | null> {
  try {
    const res = await fetcher(
      `documents/download`,
      {
        method: 'POST',
        body,
      },
      undefined
    );

    if (!res.ok) return null;

    const response = await res.blob();

    return response;
  } catch (err) {
    console.error(err);
    throw err;
  }
}
